import { render, staticRenderFns } from "./decorator.vue?vue&type=template&id=649edaee&"
import script from "./decorator.vue?vue&type=script&lang=ts&"
export * from "./decorator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('649edaee')) {
      api.createRecord('649edaee', component.options)
    } else {
      api.reload('649edaee', component.options)
    }
    module.hot.accept("./decorator.vue?vue&type=template&id=649edaee&", function () {
      api.rerender('649edaee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/searchbar/decorators/decorator.vue"
export default component.exports